


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Notification, NotificationType } from './NotificationBanner.models';

@Component({})
export default class NotificationBanner extends Vue {
  private NotificationType: typeof NotificationType = NotificationType;

  @Prop() private notification!: Notification;

  @Emit('close')
  private closeClicked() {
    return this.notification.key;
  }
}
